import {Component, OnDestroy, OnInit} from '@angular/core';

import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {UserService} from './Services/user.service';
import {MessagingService} from './Services/messaging.service';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {BnNgIdleService} from 'bn-ng-idle';
import {zendeskLogOut} from 'src/app/Services/zendesk.service';
import {CustomUrlSerializer} from './shared/models/UrlSerializer/custom-url-serializer';
import {FirebaseService} from './shared/services/firebase.service';
import {ToastrService} from 'ngx-toastr';
import {StartWatchIdleTimer} from './Services/start-watch-idle-timer.service';

declare var $: any;
declare var grecaptcha: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'webapp';
  message: any;
  interval: any;
  userData: any = {};
  isButton: any = false;
  tokentimerObj: any;
  tokentime: any = 0;
  istokentime: any = false;
  timer: any = '';
  tokenExpireTime: any = 10;
  errors: any = {};
  user: any = {};
  unsubscribe$: Subject<void> = new Subject<void>();
  isReferesh: any = false;
  urlLang: any = 'en';
  urlToken: any = false;
  public imgUrl: any = environment.imgUrl;

  constructor(
    private firebase: FirebaseService,
    private messagingService: MessagingService,
    private userService: UserService,
    private activeRouter: ActivatedRoute,
    private cookieService: CookieService,
    private translate: TranslateService,
    private toast: ToastrService,
    private router: Router,
    private titleService: Title,
    private bnIdle: BnNgIdleService,
    private startWatchIdleTimer: StartWatchIdleTimer
  ) {

    if (!environment.production) {
      console.log('APP Component');
    }
    // this.myUndefinedFunction()
    let title = 'Obsidiam - Buy, Sell and Exchange Digital Assets in your country and the world';
    if (environment.env == 'dev') {
      title = 'Dev-' + title;
    } else if (environment.env == 'stage') {
      title = 'Stage-' + title;
    }
    this.titleService.setTitle(title);
    this.activeRouter.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((a) => {
      if (a.language) {
        this.cookieService.set('OBSIDIAM-LOCALE', a.language, new Date(new Date().getTime() + environment.cookieExpireTime), '/', window.location.hostname, true, 'Strict');
      }
      if (a.token) {
        this.urlToken = true;
      }
    });

    this.userData = this.userService.getLoggedData();
    let tokenData = this.userService.getToken();
    if (tokenData.token && !this.urlToken) {
      this.tokentime = (this.tokenExpireTime * 60 * 1000) - (new Date().getTime() - new Date(tokenData.createdAt).getTime());
      this.tokentimerObj = setInterval(() => {
        this.tokenTimer();
      }, 1000);
      this.refreshToken();

    }

    const locale = this.cookieService.get('OBSIDIAM-LOCALE') || 'en';
    if (!environment.production) {
      console.log('App.component', locale);
    }
    this.translate.setDefaultLang(locale.toLocaleLowerCase());
    this.translate.use(locale.toLocaleLowerCase());

    this.router.events.subscribe((val) => {
      // see also

      if (val instanceof NavigationEnd) {
        // console.log(CustomUrlSerializer.decript(val.url))
        setTimeout(() => {
          this.modeSwitch();
          let url = CustomUrlSerializer.decript(val.url).split('/');
          url = url[1].split('?');

          if (['', 'login', 'subscribe', 'verify',
            'forgot-password', 'reset-password', 'info',
            'confirmation', 'verify-account', 'start-verification', 'user-origin',
            'welcome', 'verify-email'].indexOf(url[0]) != -1) {
            $('body').addClass('bgcolor');
          } else {
            $('body').removeClass('bgcolor');
          }
        }, 100);
      }
    });

    this.loadScript();
  }


  loadScript() {
    const bodyElements = document.getElementsByTagName('body');
    const headElements = document.getElementsByTagName('head');

    const scriptZendesk = document.createElement('script');
    scriptZendesk.src = 'https://static.zdassets.com/ekr/snippet.js?key=e6d46454-fb8c-4402-bbb0-1ab3d25de810';
    scriptZendesk.type = 'text/javascript';
    scriptZendesk.id = 'ze-snippet';
    bodyElements[0].appendChild(scriptZendesk);

    // add script recaptcha
    const recaptcha = document.createElement('script');
    recaptcha.src = 'https://www.google.com/recaptcha/enterprise.js?render=6LfZG74jAAAAAHwWJa9Cupa3dXwN4JnPR_CAsAz7';
    recaptcha.type = 'text/javascript';
    recaptcha.id = 'recaptcha-snippet';
    recaptcha.text = 'grecaptcha.enterprise.ready(function() {\n' +
      'grecaptcha.enterprise.execute("6LfZG74jAAAAAHwWJa9Cupa3dXwN4JnPR_CAsAz7", {action: "login"}).then(function(token) {\n'+
    '\n' +
      '});\n' +
      '});'
    headElements[0].appendChild(recaptcha);
    // add css paymentsway
    const psePaymentcss = document.createElement('link');
    psePaymentcss.href = ' https://merchant.paymentsway.co/assetsWidget/css/index.css';
    psePaymentcss.rel = 'stylesheet';
  
    headElements[0].appendChild(psePaymentcss);

    // add script paymetsWay
    const psePayment = document.createElement('script');
    psePayment.src = 'https://merchant.paymentsway.co/assetsWidget/js/index.js' //'/assets/js/paymentWay.js';
    psePayment.type = 'text/javascript';
    bodyElements[0].appendChild(psePayment);

    
    const scriptZendesk2 = document.createElement('script');
    scriptZendesk2.type = 'text/javascript';
    scriptZendesk2.text = ' var waitForZopim = setInterval(function () {\n' +
      '      if (window.$zopim === undefined || window.$zopim.livechat === undefined) {\n' +
      '        return;\n' +
      '      }\n' +
      '      $zopim(function () {\n' +
      '        $zopim.livechat.setLanguage(this.currentLang);\n' +
      '        $zopim.livechat.theme.setColor(\'#008cf3\');\n' +
      '      });\n' +
      '      clearInterval(waitForZopim);\n' +
      '    }, 100);';
    bodyElements[0].appendChild(scriptZendesk2);

    const scriptJsapi = document.createElement('script');
    scriptJsapi.src = '  https://www.google.com/jsapi?key=AIzaSyC3wRx_enKQ1CN2u6yl8Yswazly1qj8obo';
    scriptJsapi.type = 'text/javascript';
    bodyElements[0].appendChild(scriptJsapi);

    if (environment.production) {
      const scriptGoogleTag = document.createElement('script');
      scriptGoogleTag.type = 'text/javascript';
      scriptGoogleTag.text = '// CODIGO GOOGLE TAG COLTEFINANCIERA\n' +
        '(function (w, d, s, l, i) {\n' +
        '    w[l] = w[l] || [];\n' +
        '    w[l].push({\n' +
        '      \'gtm.start\':\n' +
        '        new Date().getTime(), event: \'gtm.js\'\n' +
        '    });\n' +
        '    var f = d.getElementsByTagName(s)[0],\n' +
        '      j = d.createElement(s), dl = l != \'dataLayer\' ? \'&l=\' + l : \'\';\n' +
        '    j.async = true;\n' +
        '    j.src =\n' +
        '      \'https://www.googletagmanager.com/gtm.js?id=\' + i + dl;\n' +
        '    f.parentNode.insertBefore(j, f);\n' +
        '  })(window, document, \'script\', \'dataLayer\', \'GTM-TBDRT85\');';
      headElements[0].appendChild(scriptGoogleTag);

      const scriptGoogleTagBody = document.createElement('noscript');
      scriptGoogleTagBody.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TBDRT85"\n' +
        '      height="0" width="0" style="display:none;visibility:hidden"></iframe>';
      bodyElements[0].appendChild(scriptGoogleTagBody);
    }
  }

  millisecondsToTime(milli) {
    const pad = (n, z = 2) => ('00' + n).slice(-z);
    const seconds = Math.floor((milli / 1000) % 60);
    const minutes = Math.floor((milli / (60 * 1000)) % 60);

    return pad(minutes) + ':' + pad(seconds);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  tokenTimer() {
    this.userData = this.userService.getLoggedData();
    let tokenData = this.userService.getToken();
    if (tokenData.token) {
      this.tokentime = (this.tokenExpireTime * 60 * 1000) - (new Date().getTime() - new Date(tokenData.createdAt).getTime());
      if (this.tokentime <= (60 * 1 * 1000) && this.tokentime > 0) {
        if (this.router.url.indexOf('login') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('subscribe') == -1 && this.router.url.indexOf('forgot-password') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('welcome') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('password') == -1) {
          this.timer = this.millisecondsToTime((this.tokenExpireTime * 60 * 1000) - (new Date().getTime() - new Date(tokenData.createdAt).getTime()));
          this.istokentime = true;
          if (this.tokentime <= 0) {

            this.logOut();
            clearInterval(this.tokentimerObj);
            this.istokentime = false;
            this.timer = '';
          }

        }
      } else {
        if (this.tokentime <= (60 * 5 * 1000) && !this.isReferesh) {
          clearInterval(this.tokentimerObj);
          this.refreshToken();
        }
        if (this.istokentime) {
          this.timer = this.millisecondsToTime((this.tokenExpireTime * 60 * 1000) - (new Date().getTime() - new Date(tokenData.createdAt).getTime()));
        }
      }
    } else {
      if (CustomUrlSerializer.decript(this.router.url).indexOf('login') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('subscribe') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('forgot-password') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('welcome') == -1 && CustomUrlSerializer.decript(this.router.url).indexOf('password') == -1) {

        this.logOut();
      }
      clearInterval(this.tokentimerObj);
      this.timer = '';
      this.istokentime = false;
    }
  }

  refreshToken() {
    this.isReferesh = true;
    this.userData = this.userService.getLoggedData();
    let tokenData = this.userService.getToken();
    if (tokenData.token) {
      this.userService.refreshToken(tokenData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((refresh: any) => {
        this.isReferesh = false;
        if (refresh.status !== 200) {
          if (!environment.production) {
            console.log('refresh failed');
          }

          this.logOut();
        } else {

          // if (!environment.production)
          //   console.log('REFRESH', this.userData, refresh.data.token);
          this.userService.setToken(refresh.data.token);
          setTimeout(() => {
            this.userService.changeToken();
            clearInterval(this.tokentimerObj);
            this.tokentime = (this.tokenExpireTime * 60 * 1000) - (new Date().getTime() - new Date(tokenData.createdAt).getTime());
            this.tokentimerObj = setInterval(() => {
              this.tokenTimer();
            }, 1000);
          }, 100);
          const url = CustomUrlSerializer.decript(this.router.url);

        }
      });
    }
  }

  islogin() {
    if (!environment.production) {
      console.log(CustomUrlSerializer.decript(this.router.url));
    }
    let urls = [
      '/',
      'market',
      'buy-sell-market',
      'about-us',
      'fee',
      'privacy-policy',
      'term-and-condition',
      'subscribe',
      'subscribe',
      'login',
      'forgot-password',
      'reset-password',
      'info',
      'confirmation',
      'verify-email',
      'verify-account',
      'change-phone',
      'check-sms-phone',
      'start-verification',
      'user-origin',
      //"verification-guide",
      'verification-error',
      'welcome',
      'verify',
      // "price-equation",
      // "profit-calculation",
      // "reputation-calculation"
    ];
    for (let i = 0; i < urls.length; i++) {
      if (CustomUrlSerializer.decript(this.router.url).indexOf(urls[i])) {
        this.router.navigate(['/dashboard']);
        break;
      }
    }
  }

  logOut() {
    if (!environment.production) {
      console.log('logout');
    }
    $('.modal').modal('hide');
    this.cookieService.deleteAll('/', location.hostname);
    this.userService.deleteUserData();
    this.userService.deleteToken();
    this.userService.isLoggedIn = false;
    this.userService.setUserData({});
    this.userService.setToken('');
    localStorage.clear();
    this.userData = this.userService.getLoggedData();
    if (!environment.production) {
      console.log('APP 436: HIT LOG OUT EVENT');
    }
    this.userService.logOutEventHit();
    this.router.navigate(['/login']);
  }

  logOutUserIfUserLoggedIn() {
    const isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    const data = {source: isMobile ? 'Mobile' : 'Website'};
    this.userService.logout(data, this.userData.token).pipe(takeUntil(this.unsubscribe$)).subscribe((n: any) => {
      if (n.status === 200) {
        zendeskLogOut();
        this.cookieService.deleteAll('/');
        this.userService.deleteUserData();
        this.userService.deleteToken();
        this.userService.isLoggedIn = false;
        this.userService.setUserData({});
        this.userService.setToken('');
        this.messagingService.changeVerificationStatus();

        $('#sessionExpiredModal').modal('hide');
        this.bnIdle.resetTimer();
        sessionStorage.setItem('cookies', this.cookieService.get('cookies') ? JSON.parse(this.cookieService.get('cookies')) : '');
        sessionStorage.setItem('takeFeeOff', this.cookieService.get('takeFeeOff') ? JSON.parse(this.cookieService.get('takeFeeOff')) : '');
        sessionStorage.setItem('rememberLate', this.cookieService.get('rememberLate') ? JSON.parse(this.cookieService.get('rememberLate')) : '');
        this.cookieService.delete('cookies');
        this.cookieService.delete('takeFeeOff');
        this.cookieService.delete('rememberLate');
        localStorage.clear();

        if (!environment.production) {
          console.log('SIDEBAR 149: HIT LOG OUT EVENT');
          // console.log('this.cookieService.get(environment.authName);', this.cookieService.get(environment.authName))
        }
        this.userService.logOutEventHit();
        this.router.navigate(['/login']);
        this.translate.get('session_expired_inactivity').pipe(takeUntil(this.unsubscribe$)).subscribe((msg: any) => {
          this.toast.error('', msg, {
            timeOut: 15000
          });
        });
      }
    });
  }

  ngOnInit() {

    this.userService.logoutEvent.subscribe((a) => {
      // if (!environment.production)
      //   console.log(CustomUrlSerializer.decript(this.router.url));

    });
    this.startWatchIdleTimer.startWatchIdleTimer.pipe(takeUntil(this.unsubscribe$)).subscribe((tabName: any) => {
      //this event fires after obtainDynamicparameter api hit so after its success or fail we initialise the timer
      let tokenData = this.userService.getToken();
      //takes time in seconds
      // let m = localStorage.getItem('SESSION_EXPIRE_MODAL');
      // if (m == 'show' && tokenData.token) {
      if (this.cookieService.get('SESSION_EXPIRE_MODAL') == 'show' && tokenData.token) {
        // this.cookieService.get('SESSION_EXPIRE_MODAL') ---> this cookie used to check the session expire popup open state on reloading of site
        if (!environment.production) {
          console.log('check for first time');
        }
        this.user.password = '';
        $('#sessionExpiredModal').modal('show');
        this.setShowHideSessionCookie('show');
      } else {
        this.setShowHideSessionCookie('hide');
      }
      if (!environment.production) {
        console.log('timer subscribed', environment.obsicash.sessionTimeout);
      }
      this.bnIdle.startWatching(environment.obsicash.sessionTimeout * 60).subscribe((res) => {
        if (res) {
          if (!environment.production) {
            console.log(environment.obsicash.sessionTimeout, 'autoLogoutTime', $('#sessionExpiredModal').hasClass('show'), this.cookieService.get('SESSION_EXPIRE_MODAL'), new Date().getTime());
          }
          tokenData = this.userService.getToken();
          if (tokenData.token && !$('#sessionExpiredModal').hasClass('show')) {
            this.user.username = this.userService.getLoggedData().username;
            this.user.password = '';
            $('#sessionExpiredModal').modal('show');
            this.setShowHideSessionCookie('show');
          }
        }
      });
    });
    this.userService.resetTimerEvent.pipe(takeUntil(this.unsubscribe$)).subscribe((m) => {
      this.tokentime = 0;
    });
    this.userService.startTimerEvent.pipe(takeUntil(this.unsubscribe$)).subscribe((m) => {
      this.userData = this.userService.getLoggedData();
      let tokenData = this.userService.getToken();
      clearInterval(this.tokentimerObj);
      this.isReferesh = false;
      this.tokentime = (this.tokenExpireTime * 60 * 1000) - (new Date().getTime() - new Date(tokenData.createdAt).getTime());
      this.tokentimerObj = setInterval(() => {
        this.tokenTimer();
      }, 1000);
    });
    if (window.history && window.history.pushState) {

      $(window).on('popstate', () => {
        $('.modal').modal('hide');
      });
    }
    $(window).on('shown.bs.modal', () => {
      $('body').addClass('modal-open');
    });
    $(window).on('hidden.bs.modal', () => {
      $('body').removeClass('modal-open');
    });
    $('.modal').on('shown.bs.modal', () => {
      $('body').addClass('modal-open');
    });
    $('.modal').on('hidden.bs.modal', () => {
      $('body').removeClass('modal-open');
    });
    if (this.userService.getBrowserName() !== 'safari') {
      this.messagingService.change.pipe(takeUntil(this.unsubscribe$)).subscribe(isOpen => {
        const userId = this.cookieService.get('firebaseUUID');
        if (userId) {
          this.messagingService.requestPermission().pipe(takeUntil(this.unsubscribe$)).subscribe(
            (token) => {
              this.messagingService.updateToken(userId, token);
            },
            (err) => {
              console.log('Unable to get permission to notify.');
            });

          this.messagingService.receiveMessage().pipe(takeUntil(this.unsubscribe$)).subscribe(
            (payload) => {
              if (!environment.production) {
                console.log('new message received. ');
              }
            });
        }
      });
    }
  }

  setShowHideSessionCookie(val) {
    // localStorage.setItem('SESSION_EXPIRE_MODAL', val);
    this.cookieService.set('SESSION_EXPIRE_MODAL', val, new Date(new Date().getTime() + environment.cookieExpireTime), '/', window.location.hostname, true, 'Strict');
  }

  modeSwitch() {
    $(window).scrollTop(0);
    $('.hamburger').removeClass('is-active');
    $('#mySidenav').removeAttr('style');
    $('.home .sidebar').removeAttr('style');
    if ($('.switch input').is(':checked')) {
      $('body').addClass('nightMode');
      localStorage.setItem('MODE', 'night');
      $('.bgcolor').addClass('nightmode');
      $('.header').addClass('fixedblack');
      $('.whiteback').css('background-color', 'transparent');
      $('.textcolor').addClass('whitetext');
      $('.switch i').text('Night');
      $('.formstyle .select_region').addClass('darkselect');
      $('.selectBx i').css('color', '#fff');
      $('.code_div .form-control').css('color', '#fff');
      $('.modal-content').css('background-color', '#000');
      $('.home_fixed').addClass('homefixedmode');
      $('.gradient-box').addClass('homefixedmode');
      $('.sidebar').addClass('homefixedmode');
      $('.getverfiy').addClass('homefixedmode');
      $('.bellicon img').attr('src', 'img/bellwhite.svg');
      $('.searchicon img').attr('src', 'https://cdn-dev.obsidiam.com/img/obsidiam_searchwhite.svg');
      $('.homemid').addClass('homemidmode');
      $('.stick_fixed').addClass('homemidmode');
      $('.bitcoin_sec').addClass('homemidmode');
      $('.drop_down').addClass('dropdownmode');
      $('.drop_down_hd').addClass('drop_down_hdmode');
      $('.drop_down2').addClass('drop_down_hdmode');
      $('.drop_down3').addClass('drop_down_hdmode');
      $('.fran').addClass('homemidmode');
      $('.whitebackmodal').css('background-color', '#000');
      $('.partially').css('border-color', '#fff');
      $('.sendcoin').css('background-color', '#97a3b4');
      $('.portfolio-Security').css('background-color', '#16252e');
      $('.btngran span').css('background', '#16252e');
      $('.dulpliimg img').attr('src', 'https://cdn-dev.obsidiam.com/img/obsidiam_whiteduplicate.svg');
    } else {
      $('body').removeClass('nightMode');
      localStorage.setItem('MODE', 'day');
      $('.bgcolor').removeClass('nightmode');
      $('.header').removeClass('fixedblack');
      $('.whiteback').css('background-color', '#fff');
      $('.textcolor').removeClass('whitetext');
      $('.switch i').text('Day');
      $('.formstyle .select_region').removeClass('darkselect');
      $('.selectBx i').css('color', '#000');
      $('.code_div .form-control').css('color', '#000');
      $('.modal-content').css('background-color', '#fff');
      $('.home_fixed').removeClass('homefixedmode');
      $('.gradient-box').removeClass('homefixedmode');
      $('.sidebar').removeClass('homefixedmode');
      $('.getverfiy').removeClass('homefixedmode');
      $('.bellicon img').attr('src', 'https://cdn-dev.obsidiam.com/img/obsidiam_bell.svg');
      $('.searchicon img').attr('src', 'https://cdn-dev.obsidiam.com/img/obsidiam_serch_black.svg');
      $('.homemid').removeClass('homemidmode');
      $('.stick_fixed').removeClass('homemidmode');
      $('.bitcoin_sec').removeClass('homemidmode');
      $('.drop_down').removeClass('dropdownmode');
      $('.drop_down_hd').removeClass('drop_down_hdmode');
      $('.drop_down2').removeClass('drop_down_hdmode');
      $('.drop_down3').removeClass('drop_down_hdmode');
      $('.fran').removeClass('homemidmode');
      $('.whitebackmodal').css('background-color', '#fff');
      $('.portfolio-Security').css('background-color', '#fff');
      $('.partially').css('border-color', '#0c133e');
      $('.btngran span').css('background', '#fff');
      $('.dulpliimg img').attr('src', 'https://cdn-dev.obsidiam.com/img/obsidiam_duplicatebig.svg');
    }
  }

  loginAgain() {
    $('#sessionExpiredModal').modal('hide');
    this.setShowHideSessionCookie('hide');
    this.bnIdle.resetTimer();
    // console.log(this.userService.getLoggedData())
  }

  validateLogin() {
    let hasError = 0;
    const arr = ['password'];
    this.errors = [];
    arr.forEach((m) => {
      if (!this.user[m]) {
        hasError += 1;
        this.errors[m] = 'login.error.' + m;
      }
    });


    return hasError > 0 ? false : true;
  }

  checkCaptcha() {
    if (!this.isButton) {
      this.isButton = true;
      if (this.validateLogin()) {
        this.userService.verifyPassword({password: this.user.password}).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
          this.isButton = false;
          this.setShowHideSessionCookie('hide');
          if (m.status === 410) {
            // account block
            this.translate.get('Error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
              const msg = m.message;
              const err = er;
              this.message = msg;
              this.toast.error(msg, err, {
                timeOut: 15000
              });
            });
            this.logOutUserIfUserLoggedIn();
          } else if (m.status === 200) {
            $('#sessionExpiredModal').modal('hide');
            this.bnIdle.resetTimer();
          } else {

            this.translate.get('Error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
              const msg = m.message;
              const err = er;
              this.message = msg;
              this.toast.error(msg, err, {
                timeOut: 15000
              });
            });
          }
        }, (err) => {
          this.isButton = false;
        });

      } else {
        this.isButton = false;
      }
    }
  }

}
